import { RetryLink } from '@apollo/client/link/retry'

import { cleanAuthenticationCookie } from '@/providers/authentication/authentication.helpers'

/**
 * @private only to be used in apolloClient.ts
 */
export const retryLink = new RetryLink({
  delay: {
    initial: 500,
    jitter: true,
    max: Infinity,
  },
  attempts: {
    max: 5,
    retryIf: (error, _operation) => {
      const { response } = error || {}
      const { status } = response || {}

      // Do not retry 400 errors (Bad Request) or 401 errors (Unauthorized)
      if (status === 400) return false

      if (status === 401) {
        cleanAuthenticationCookie()
      }

      return error ? false : !_operation.getContext().noRetry
    },
  },
})
